import script from "./reportSmsNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./reportSmsNotification.vue?vue&type=script&setup=true&lang=js"

import "./reportSmsNotification.vue?vue&type=style&index=0&id=29d48c7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29d48c7c"]])

export default __exports__